<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12 pl-6 pt-6 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuDate" :close-on-content-click="false"  transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :disabled="currentRecharge.ID > 0 && !adminRole"
                                v-model="computedDateFormatted"
                                label="Ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="chargeDate" no-title @input="dateChanged"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-autocomplete :disabled="currentRecharge.ID > 0" label="Khách hàng" v-model="currentRecharge.UID" :items="customers" item-text="Username" item-value="ID" clearable></v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input :disabled="currentRecharge.ID > 0" v-model="currentRecharge.Amount" :decimal="0" label="Số tiền" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-select label="Hình thức" :disabled="!adminRole && currentRecharge.ID > 0" v-model="currentRecharge.Method" :items="config_methods" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-textarea :disabled="!adminRole && currentRecharge.ID > 0" label="Ghi chú" v-model="currentRecharge.TradeContent" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <div class="image-attachment-container">
                        <label class="subtitle-2 mb-2 d-block">
                            Ảnh đính kèm (chứng từ)
                            <span v-if="images.length > 0" class="caption grey--text text--darken-1">({{ images.length }} ảnh)</span>
                        </label>
                        <div v-if="images.length > 0" class="image-list-container d-flex flex-wrap">
                            <div v-for="(img, idx) in images" :key="idx" class="image-item-wrapper mr-3 mb-3">
                                <div class="image-preview-container">
                                    <v-img 
                                        :src="img" 
                                        width="120" 
                                        height="90" 
                                        contain
                                        class="elevation-2 rounded cursor-pointer image-item"
                                        @click="showPreview(img)"
                                    ></v-img>
                                    <v-btn 
                                        v-if="adminRole || currentRecharge.ID == 0"
                                        fab
                                        x-small
                                        color="red"
                                        class="image-delete-btn"
                                        @click.stop="removeImage(idx)"
                                        :disabled="!adminRole && currentRecharge.ID > 0"
                                    >
                                        <v-icon small color="white">fa-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" multiple>
                    <v-btn 
                        :disabled="(!adminRole && currentRecharge.ID > 0) || uploading"
                        :loading="uploading"
                        color="primary" 
                        @click="chooseImage"
                        outlined
                        small
                    >
                        <v-icon left>fa-camera</v-icon>
                        {{ images.length > 0 ? 'Thêm ảnh' : 'Đính kèm ảnh' }}
                    </v-btn>
                </v-flex>
                <v-layout class="d-flex flex-row" v-if="!currentRecharge.ID">
                    <v-flex lg7 md7 sm7>
                        <v-btn block color="#a77800" dark @click="saveData">
                            Nạp tiền
                        </v-btn>
                    </v-flex>
                    <v-flex lg5 md5 sm5 pr-8>
                        <v-btn block color="second" dark @click="clearData">
                            Hủy lệnh
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-card>
    </v-container>
    <div class="page-header-left pl-3 pt-5">
        <h3>Lịch sử nạp tiền</h3>
    </div>
    <recharge-list :needRefesh="needRefesh"></recharge-list>

    <!-- Dialog xem ảnh phóng to -->
    <v-dialog v-model="previewDialog" max-width="800px">
        <v-card>
            <v-card-title class="subtitle-1 py-2 px-4 d-flex justify-space-between align-center">
                <span>Xem ảnh chứng từ</span>
                <v-btn icon small @click="previewDialog = false">
                    <v-icon small>fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-2 text-center">
                <v-img :src="previewImgSrc" max-width="100%" max-height="550" contain class="rounded"></v-img>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import {
    sendErrorNotice
} from '@/commons/utils';
import recharge_list from "./list.vue";
import moment from "moment";
export default {
    components: {
        "recharge-list": recharge_list
    },
    data() {
        return {
            recharge_status: configs.RECHARGE_STATUS,
            recharge_status_list: configs.RECHARGE_STATUS_LIST,
            editStatus: 1,
            needRefesh: false,
            menuDate: false,
            chargeDate: moment.utc(Date.now()).toISOString().substr(0, 10),
            currentDate: moment.utc(Date.now()).toISOString().substr(0, 10),
            images: [],
            selectedFiles: [],
            uploading: false,
            previewDialog: false,
            previewImgSrc: ''
        };
    },
    computed: {
        ...mapState({
            customers: state => state.customer.all.data,
            loading: state => state.rechargeHistory.loading,
            currentRecharge: state => state.rechargeHistory.selected,
            configuration: state => state.configuration.selected,
        }),
        rechargeId() {
            return this.$route.params.Pid;
        },
        computedDateFormatted () {
            return this.currentRecharge && this.currentRecharge.CreatedDate && this.currentRecharge.ID > 0 ? moment.utc(this.currentRecharge.CreatedDate).format(configs.SHORT_DATE_FORMAT) : moment.utc(this.chargeDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        config_methods() {
            const conf = this.configuration.ReExMethods ? JSON.parse(this.configuration.ReExMethods) : [];
            return conf.concat(configs.RECHARGE_METHODS);
        },
    },
    watch: {
        currentRecharge: {
            handler() {
                if (this.rechargeId > 0) {
                    this.editStatus = this.currentRecharge.Status;
                } else {
                    this.editStatus = this.recharge_status.Approved;
                }
                if(this.currentRecharge && this.currentRecharge.CreatedDate > 0) {
                    this.chargeDate = moment.utc(this.currentRecharge.CreatedDate).toISOString().substr(0, 10)
                } 
                this.syncImages();
            },
            deep: true
        },
        rechargeId() {
            this.refreshData();
        }
    },
    methods: {
        syncImages() {
            if (!this.currentRecharge) {
                this.images = [];
                return;
            }
            if (this.currentRecharge.Images) {
                if (Array.isArray(this.currentRecharge.Images)) {
                    this.images = [...this.currentRecharge.Images];
                    return;
                }
                if (typeof this.currentRecharge.Images === 'string') {
                    try {
                        const parsed = JSON.parse(this.currentRecharge.Images);
                        if (Array.isArray(parsed)) {
                            this.images = parsed;
                            return;
                        }
                    } catch (e) {
                        if (this.currentRecharge.Images.trim()) {
                            this.images = [this.currentRecharge.Images.trim()];
                            return;
                        }
                    }
                }
            }
            if (this.currentRecharge.ImageUrl) {
                this.images = [this.currentRecharge.ImageUrl];
            } else {
                this.images = [];
            }
        },
        showPreview(img) {
            this.previewImgSrc = img;
            this.previewDialog = true;
        },
        refreshData() {
            this.getCustomerList();
            if (this.rechargeId > 0) {
                this.$store.dispatch("rechargeHistory/getDetail", this.rechargeId);
            }
            else {
                this.clearData();
            }
        },
        clearData() {
            if (!this.rechargeId) {
                this.images = [];
                this.$store.commit("rechargeHistory/setDetail", {
                    data: {
                        ID: 0,
                        UID: 0,
                        Method: 4,
                        Username: '',
                        Amount: 0,
                        Status: this.recharge_status.Approved,
                        TradeContent: '',
                        ImageUrl: '',
                        Images: '[]'
                    }
                });
            }
        },
        dateChanged(val) {
            this.currentRecharge.CreatedDate = moment(this.chargeDate).format(configs.SQL_DATE_FORMAT);
            this.menuDate = false;
        },
        saveData() {
            this.needRefesh = false;
            if (this.currentRecharge.Amount <= 0) {
                sendErrorNotice(`Hãy nhập số tiền muốn nạp`);
                return;
            }
            if (this.currentRecharge.ID > 0 && this.currentRecharge.Status === this.editStatus) {
                let payload = {
                    data: {
                        Method: this.currentRecharge.Method,
                        TradeContent: this.currentRecharge.TradeContent,
                        ImageUrl: this.images.length > 0 ? this.images[0] : '',
                        Images: JSON.stringify(this.images)
                    },
                    id: this.currentRecharge.ID
                };
                if(this.currentDate != this.chargeDate) {
                    payload.data.CreatedDate = moment(this.chargeDate).format(configs.SQL_DATE_FORMAT);
                }
                if(this.adminRole){
                    this.$store.dispatch("rechargeHistory/setDetail", payload);
                }
                return;
            }
            this.currentRecharge.Status = this.editStatus;
            let customer = _.find(this.customers, {
                ID: this.currentRecharge.UID
            });
            if (customer) {
                this.currentRecharge.Username = customer.Username;
            }
            this.currentRecharge.RechargeID = this.$store.state.authentication.user.userid;
            this.$store.dispatch("rechargeHistory/setDetail", {
                data: {
                    ...this.currentRecharge,
                    ImageUrl: this.images.length > 0 ? this.images[0] : '',
                    Images: JSON.stringify(this.images),
                    CreatedDate: this.currentDate != this.chargeDate ? moment(this.chargeDate).format(configs.SQL_DATE_FORMAT) : null
                },
                id: this.currentRecharge.ID
            });
            if (!this.currentRecharge.ID || this.currentRecharge.ID === 0) {
                this.images = [];
                this.$store.commit("rechargeHistory/setDetail", {
                    data: {
                        ID: 0,
                        UID: 0,
                        Method: 4,
                        Username: '',
                        Amount: 0,
                        Status: this.recharge_status.Approved,
                        TradeContent: '',
                        ImageUrl: '',
                        Images: '[]',
                        CreatedDate: moment.utc(Date.now()),
                    }
                });
            }
            this.needRefesh = true;

        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
        chooseImage() {
            this.$refs.fileInput.click();
        },
        previewImage(event) {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            this.selectedFiles = Array.from(files);
            this.$refs.fileInput.value = null;
            this.onUpload();
        },
        onUpload() {
            if (!this.selectedFiles || this.selectedFiles.length === 0) return;

            let token = this.$store.state.authentication.token;
            let options = {};
            if (token) {
                options.headers = {
                    'Authorization': `Bearer ${token}`
                };
            }

            this.uploading = true;
            const uploadPromises = this.selectedFiles.map(file => {
                let formData = new FormData();
                formData.append('file', file);
                return this.$http.post(`${process.env.VUE_APP_ENDPOINT}/admin/api/upload/`, formData, options);
            });

            Promise.all(uploadPromises)
                .then(responses => {
                    const newUrls = [];
                    responses.forEach(res => {
                        const result = res.data || res.body;
                        if (result && result.data) {
                            const url = result.data.url || (result.data.urls && result.data.urls[0]);
                            if (url) newUrls.push(url);
                        }
                    });
                    if (newUrls.length > 0) {
                        this.images.push(...newUrls);
                        this.currentRecharge.Images = JSON.stringify(this.images);
                        this.currentRecharge.ImageUrl = this.images[0] || '';
                    } else {
                        sendErrorNotice('Tải ảnh lên thất bại!');
                    }
                })
                .catch(err => {
                    let errMsg = 'Có lỗi xảy ra khi tải ảnh lên!';
                    if (err && (err.data || err.body)) {
                        const errPayload = err.data || err.body;
                        if (errPayload.reason) {
                            errMsg = errPayload.reason;
                        }
                    }
                    sendErrorNotice(errMsg);
                })
                .finally(() => {
                    this.uploading = false;
                    this.selectedFiles = [];
                });
        },
        removeImage(index) {
            this.images.splice(index, 1);
            this.currentRecharge.Images = JSON.stringify(this.images);
            this.currentRecharge.ImageUrl = this.images[0] || '';
        },
    },
    mounted() {
        this.refreshData();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.currentRecharge.UID = Number(this.$route.query.uid);
        }
        this.syncImages();
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style scoped>
.image-attachment-container {
    margin-bottom: 16px;
}

.image-preview-container {
    position: relative;
    display: inline-block;
}

.image-item {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    transition: transform 0.2s;
}

.image-item:hover {
    transform: scale(1.03);
}

.cursor-pointer {
    cursor: pointer;
}

.image-delete-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 2;
}

.image-delete-btn:hover {
    transform: scale(1.1);
}
</style>
